/**
 * @callback GetLocalization
 * @param {string} localizationPath
 * @param {object} [localizationFormat]
 * @returns {string}
 */

/**
 * Return string for page header
 * @param {object} params
 * @param {GetLocalization} params.t
 * @param {boolean} params.isNewCart
 * @param {boolean} params.isNewMethod
 * @param {object} params.order
 * @param {object} params.page
 * @param {object} params.payment
 * @returns {string}
 */
export default function pageHeader({ isNewCart, isNewMethod, order, page, payment, t }) {
	const shoppingCartPage = () => {
		if (isNewMethod) {
			return t('shoppingCart_headlineAddPayment');
		} else if (!order.isGuest) {
			return t('shoppingCart_headlineConfirm');
		} else if (order.hasTrialProduct && isNewCart) {
			return t('shoppingCart_headlinePreselection');
		} else {
			return t('shoppingCart_headline');
		}
	};
	const paymentDetailsPage = () => {
		return t('paymentDetails_title');
	};
	const companyDetailsPage = () => {
		return t('companyDetails_title');
	};
	const confirmOrderPage = () => {
		return t('confirmOrder_title');
	};
	const thankYouPage = () => {
		if (payment.isOffline) {
			return t('thankYou_offlineInstructionsHeading');
		} else if (order.hasTrialProduct) {
			return t('thankYou_headingTrial');
		} else {
			return t('thankYou_heading');
		}
	};
	const invoicePage = () => {
		return t('invoice_title');
	};
	const methodsMap = {
		'shopping-cart': shoppingCartPage,
		'payment-details': paymentDetailsPage,
		'company-details': companyDetailsPage,
		'confirm-order': confirmOrderPage,
		'thank-you': thankYouPage,
		invoice: invoicePage
	};
	return typeof methodsMap[page.alias] === 'function' ? methodsMap[page.alias]() : '';
}
